import { unwrap } from "@nexxt/api-client";
import { queryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the emails the signed-in user may turn off (ADR-149 point 7): only their own, every user.

const mine = api.notifications.preferences.me;

const keys = { all: ["notification-preferences"] as const };

export const preferenceQueries = {
  ...keys,

  mine: () =>
    queryOptions({
      queryKey: [...keys.all, "mine"],
      queryFn: ({ signal }) => unwrap(mine.$get({}, { init: { signal } })),
    }),
};
